import React from "react";
import Spinner from "react-webpack-spinner";

const Admin = props => {
  const { isLoadingUsers, users } = props;
  const bcc =
    "mailto:system@koeln-atlas.info?bcc=" +
    users
      .map(user => {
        return `${user.email}`;
      })
      .join(",");
  return (
    <div className="content">
      <h1 className="title">Admin</h1>
      {isLoadingUsers ? (
        <Spinner width={32} height={32} color="#000" />
      ) : (
        <a className="button is-info" href={bcc}>
          Rundmail an alle aktiven Benutzer
        </a>
      )}
    </div>
  );
};

export default Admin;



/** WEBPACK FOOTER **
 ** ./src/components/Admin.jsx
 **/